import { Button } from '@/components/ui/button';
import Link from '@/components/utilities/SmartLink';
import { Icon } from '@/components/ui/icon';
import VisibleLoading from '@/components/utilities/VisibleLoading';
import { useInquiryModal } from '@/components/utilities/InquiryModalContext';

const Buttons = ({ align, buttons }) => {
  const { open } = useInquiryModal();

  let alignmentClass = 'justify-center';
  if (align === 'left') {
    alignmentClass = 'justify-start';
  } else if (align === 'right') {
    alignmentClass = 'justify-end';
  }

  return (
    <div className={`mt-6 mb-6 flex flex-wrap ${alignmentClass} gap-2`}>
      {buttons.map((button, index) => (
        <VisibleLoading key={button.id} delay={(index + 1) * 200}>
          {({ ref, className }) => {
            const mergedClassName = `basis-full xl:basis-auto ${className || ''}`.trim();

            if (button.serviceId) {
              return (
                <Button
                  ref={ref}
                  variant={button.variant}
                  size={button.size}
                  type="button"
                  onClick={() => open(button.serviceId)}
                  className={mergedClassName}
                >
                  <Icon type={button.icon} /> {button.label}
                </Button>
              );
            }

            return (
              <Button
                ref={ref}
                variant={button.variant}
                size={button.size}
                asChild={true}
                className={mergedClassName}
              >
                <Link href={button.url || ''}>
                  <Icon type={button.icon} /> {button.label}
                </Link>
              </Button>
            );
          }}
        </VisibleLoading>
      ))}
    </div>
  );
};
export default Buttons;
